export default __webpack_public_path__ + "static/media/Roboto-Thin.7ab73fde.woff";